import React from 'react'
import {CardBox, CardButtonBox, CardText, CardTitle, Divider} from './styles'
import ReferIcon from '../../../../images/icons/new-dashboard/refer-icon.svg'
import {Button} from '../../../../components/button'
import {trackReferralsProgramClick} from '../../../../redux/members'
import {useAuth} from '../../../../components/AuthProvider'
import {useAppDispatch} from '../../../../redux/configureStore'

const View = () => {
  const auth = useAuth()
  const dispatch = useAppDispatch()

  return (
    <CardBox>
      <CardTitle>
        <img src={ReferIcon} alt="Upgrade to Expert" />
        <span>Refer Friends, Get $50</span>
      </CardTitle>
      <Divider />
      <CardText>Sign Up for the Referral Program Today!</CardText>
      <CardButtonBox>
        <Button
          color="secondary"
          children={'Sign Up Today'}
          onClick={() => {
            if (auth.isAuthenticated) {
              dispatch(trackReferralsProgramClick({auth}))
            }

            window.open('https://www.blackspectacles.com/referral')
          }}
        />
      </CardButtonBox>
    </CardBox>
  )
}

export default View
